import { enumerable } from '../utils';

export const CATEGORY_TYPE = enumerable(
  'Holiday',
  'Birthday',
  'Busy',
  'Anniversary',
  'None'
);



// WEBPACK FOOTER //
// ./src/components/consts.js